export enum DomElement {
  Document = 'document'
}
